// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"a317818d","598":"d7dd3135","703":"f569a42d"}[chunkId] + ".chunk.js";
};